window.addEventListener("load", () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        let target = entry.target
        if (!target.classList.contains("selectized")) {
          $(target).selectize()
        }
      }
    })
  })

  let selectizeElements = document.querySelectorAll(".selectize")
  selectizeElements.forEach(selectizeElement => {
    observer.observe(selectizeElement)
  })
})
